// extracted by mini-css-extract-plugin
export default {"wrapper":"Table_wrapper__B6aCW","header":"Table_header__rwKnO","row-custom":"Table_row-custom__wn1yz","row":"Table_row__vg-qa"};